export default __webpack_public_path__ + "static/media/player-fast-forward.aac709f0.svg";